(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["Ugc-Hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initHeroBanner(sectionEl) {
      var sectionId = sectionEl.id.replace('shopify-section-', '');
      var dataEl = document.getElementById('hero-data-' + sectionId);
      if (!dataEl) return;

      var data = JSON.parse(dataEl.textContent);
      var images = data.images || [];
      var words = data.words || [];
      var gallerySpeed = data.gallerySpeed || 10;
      var wordSpeed = data.wordSpeed || 1500;

      buildGallery(sectionId, images, gallerySpeed);
      buildMobileGallery(sectionId, images, gallerySpeed);
      initWordRotation(sectionId, words, wordSpeed);
    }

    /* Split images evenly across columns (e.g. 12 images / 3 cols = 4 per col) */
    function computeColumnOrders(count, numCols) {
      var cols = [];
      var perCol = Math.ceil(count / numCols);
      for (var c = 0; c < numCols; c++) {
        var col = [];
        var start = c * perCol;
        var end = Math.min(start + perCol, count);
        for (var i = start; i < end; i++) {
          col.push(i);
        }
        cols.push(col);
      }
      return cols;
    }

    /* Placeholder SVG for empty image blocks */
    function placeholderSVG(index) {
      var hues = [210, 260, 320, 160, 40, 190];
      var h = hues[index % hues.length];
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="300" height="400" viewBox="0 0 300 400">' +
        '<rect width="300" height="400" fill="hsl(' + h + ',40%,15%)"/>' +
        '<rect x="80" y="140" width="140" height="120" rx="12" fill="hsl(' + h + ',50%,25%)"/>' +
        '<text x="150" y="210" text-anchor="middle" fill="hsl(' + h + ',60%,50%)" font-size="14" font-family="sans-serif">Upload Image</text>' +
        '</svg>';
      return 'data:image/svg+xml,' + encodeURIComponent(svg);
    }

    /* Desktop vertical gallery */
    function buildGallery(sectionId, images, speedSetting) {
      var container = document.getElementById('gallery-' + sectionId);
      if (!container || !images.length) return;

      /* speedSetting range: 5 (slow) to 30 (fast), default 10
         Formula: BASE * 10 / speedSetting
         At default 10: 40*10/10 = 40s (original speed)
         At 20: 40*10/20 = 20s (2x faster)
         At 5: 40*10/5 = 80s (half speed) */
      var BASE_SPEEDS = [40, 35, 45];
      var DIRECTIONS = ['scrollUp', 'scrollDown', 'scrollUp'];
      var NUM_COLS = 3;
      var colOrders = computeColumnOrders(images.length, NUM_COLS);

      for (var ci = 0; ci < NUM_COLS; ci++) {
        var colEl = document.createElement('div');
        colEl.className = 'gallery-col';
        var dur = (BASE_SPEEDS[ci] * 10 / speedSetting).toFixed(1) + 's';
        colEl.style.animation = DIRECTIONS[ci] + ' ' + dur + ' linear infinite';

        var order = colOrders[ci];
        for (var pass = 0; pass < 2; pass++) {
          for (var i = 0; i < order.length; i++) {
            var card = document.createElement('div');
            card.className = 'gallery-card';
            var img = document.createElement('img');
            var imgUrl = images[order[i]];
            img.src = imgUrl || placeholderSVG(order[i]);
            img.alt = 'Gallery image ' + (order[i] + 1);
            img.loading = 'lazy';
            card.appendChild(img);
            colEl.appendChild(card);
          }
        }
        container.appendChild(colEl);
      }
    }

    /* Mobile horizontal gallery */
    function buildMobileGallery(sectionId, images, speedSetting) {
      var container = document.getElementById('mobile-gallery-' + sectionId);
      if (!container || !images.length) return;

      var NUM_ROWS = 2;
      var BASE_SPEEDS = [30, 35];
      var DIRECTIONS = ['scrollLeft', 'scrollRight'];
      var halfCount = Math.floor(images.length / 2);

      for (var ri = 0; ri < NUM_ROWS; ri++) {
        var wrapper = document.createElement('div');
        wrapper.className = 'mobile-gallery-container';
        var rowEl = document.createElement('div');
        rowEl.className = 'mobile-gallery-row';
        var dur = (BASE_SPEEDS[ri] * 10 / speedSetting).toFixed(1) + 's';
        rowEl.style.animation = DIRECTIONS[ri] + ' ' + dur + ' linear infinite';

        for (var pass = 0; pass < 2; pass++) {
          for (var i = 0; i < images.length; i++) {
            var idx = (i + ri * halfCount) % images.length;
            var card = document.createElement('div');
            card.className = 'mobile-gallery-card';
            var img = document.createElement('img');
            var imgUrl = images[idx];
            img.src = imgUrl || placeholderSVG(idx);
            img.alt = 'Gallery image';
            img.loading = 'lazy';
            card.appendChild(img);
            rowEl.appendChild(card);
          }
        }
        wrapper.appendChild(rowEl);
        container.appendChild(wrapper);
      }
    }

    /* Rotating words */
    function initWordRotation(sectionId, words, intervalMs) {
      if (!words || words.length < 1) return;
      var el = document.getElementById('rotating-word-' + sectionId);
      if (!el) return;

      el.textContent = words[0].text;
      el.style.color = words[0].color;

      if (words.length < 2) return;

      var idx = 0;
      setInterval(function() {
        el.classList.add('fade-out');
        setTimeout(function() {
          idx = (idx + 1) % words.length;
          el.textContent = words[idx].text;
          el.style.color = words[idx].color;
          el.classList.remove('fade-out');
          el.classList.add('fade-in');
        }, 400);
      }, intervalMs);
    }

    /* Init on page load */
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.hero-section-root').forEach(initHeroBanner);
    });

    /* Theme Editor live reload */
    document.addEventListener('shopify:section:load', function(e) {
      initHeroBanner(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fullwidth-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initHeroBanner(sectionEl) {
      var sectionId = sectionEl.id.replace('shopify-section-', '');
      var dataEl = document.getElementById('hero-data-' + sectionId);
      if (!dataEl) return;

      var data = JSON.parse(dataEl.textContent);
      var words = data.words || [];
      var wordSpeed = data.wordSpeed || 1500;

      if (!words || words.length < 1) return;
      var el = document.getElementById('rotating-word-' + sectionId);
      if (!el) return;

      el.textContent = words[0].text;
      el.style.color = words[0].color;

      if (words.length < 2) return;

      var idx = 0;
      setInterval(function() {
        el.classList.add('fade-out');
        setTimeout(function() {
          idx = (idx + 1) % words.length;
          el.textContent = words[idx].text;
          el.style.color = words[idx].color;
          el.classList.remove('fade-out');
          el.classList.add('fade-in');
        }, 400);
      }, wordSpeed);
    }

    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.hero-section-root').forEach(initHeroBanner);
    });

    document.addEventListener('shopify:section:load', function(e) {
      initHeroBanner(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mahlp-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-mvid-player]').forEach(function (p) {
      if (p.__mvidInit) return;
      p.__mvidInit = true;
      var btn = p.querySelector('.mahlp-vid__play');
      if (!btn || btn.disabled) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        p.classList.add('is-playing');
        var media = p.querySelector('[data-mvid-media]');
        var iframe = p.querySelector('[data-mvid-iframe]');
        if (media && media.tagName === 'VIDEO') {
          media.play();
        } else if (iframe) {
          var lazy = iframe.getAttribute('data-src');
          if (lazy) iframe.setAttribute('src', lazy);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toggle-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    function initHeroBanner(sectionEl) {
      var sectionId = sectionEl.id.replace('shopify-section-', '');
      var dataEl = document.getElementById('hero-data-' + sectionId);
      if (!dataEl) return;

      var data = JSON.parse(dataEl.textContent);
      var images = data.images || [];
      var words = data.words || [];
      var gallerySpeed = data.gallerySpeed || 10;
      var wordSpeed = data.wordSpeed || 1500;
      var displayMode = data.displayMode || 'gallery';

      if (displayMode === 'gallery') {
        buildGallery(sectionId, images, gallerySpeed);
        buildMobileGallery(sectionId, images, gallerySpeed);
      }

      initWordRotation(sectionId, words, wordSpeed);
    }

    /* Split images evenly across columns */
    function computeColumnOrders(count, numCols) {
      var cols = [];
      var perCol = Math.ceil(count / numCols);
      for (var c = 0; c < numCols; c++) {
        var col = [];
        var start = c * perCol;
        var end = Math.min(start + perCol, count);
        for (var i = start; i < end; i++) {
          col.push(i);
        }
        cols.push(col);
      }
      return cols;
    }

    /* Placeholder SVG for empty image blocks */
    function placeholderSVG(index) {
      var hues = [210, 260, 320, 160, 40, 190];
      var h = hues[index % hues.length];
      var svg = '<svg xmlns="http://www.w3.org/2000/svg" width="300" height="400" viewBox="0 0 300 400">' +
        '<rect width="300" height="400" fill="hsl(' + h + ',40%,15%)"/>' +
        '<rect x="80" y="140" width="140" height="120" rx="12" fill="hsl(' + h + ',50%,25%)"/>' +
        '<text x="150" y="210" text-anchor="middle" fill="hsl(' + h + ',60%,50%)" font-size="14" font-family="sans-serif">Upload Image</text>' +
        '</svg>';
      return 'data:image/svg+xml,' + encodeURIComponent(svg);
    }

    /* Desktop vertical gallery */
    function buildGallery(sectionId, images, speedSetting) {
      var container = document.getElementById('gallery-' + sectionId);
      if (!container || !images.length) return;

      var BASE_SPEEDS = [40, 35, 45];
      var DIRECTIONS = ['scrollUp', 'scrollDown', 'scrollUp'];
      var NUM_COLS = 3;
      var colOrders = computeColumnOrders(images.length, NUM_COLS);

      for (var ci = 0; ci < NUM_COLS; ci++) {
        var colEl = document.createElement('div');
        colEl.className = 'gallery-col';
        var dur = (BASE_SPEEDS[ci] * 10 / speedSetting).toFixed(1) + 's';
        colEl.style.animation = DIRECTIONS[ci] + ' ' + dur + ' linear infinite';

        var order = colOrders[ci];
        for (var pass = 0; pass < 2; pass++) {
          for (var i = 0; i < order.length; i++) {
            var card = document.createElement('div');
            card.className = 'gallery-card';
            var img = document.createElement('img');
            var imgUrl = images[order[i]];
            img.src = imgUrl || placeholderSVG(order[i]);
            img.alt = 'Gallery image ' + (order[i] + 1);
            img.loading = 'lazy';
            card.appendChild(img);
            colEl.appendChild(card);
          }
        }
        container.appendChild(colEl);
      }
    }

    /* Mobile horizontal gallery */
    function buildMobileGallery(sectionId, images, speedSetting) {
      var container = document.getElementById('mobile-gallery-' + sectionId);
      if (!container || !images.length) return;

      var NUM_ROWS = 2;
      var BASE_SPEEDS = [30, 35];
      var DIRECTIONS = ['scrollLeft', 'scrollRight'];
      var halfCount = Math.floor(images.length / 2);

      for (var ri = 0; ri < NUM_ROWS; ri++) {
        var wrapper = document.createElement('div');
        wrapper.className = 'mobile-gallery-container';
        var rowEl = document.createElement('div');
        rowEl.className = 'mobile-gallery-row';
        var dur = (BASE_SPEEDS[ri] * 10 / speedSetting).toFixed(1) + 's';
        rowEl.style.animation = DIRECTIONS[ri] + ' ' + dur + ' linear infinite';

        for (var pass = 0; pass < 2; pass++) {
          for (var i = 0; i < images.length; i++) {
            var idx = (i + ri * halfCount) % images.length;
            var card = document.createElement('div');
            card.className = 'mobile-gallery-card';
            var img = document.createElement('img');
            var imgUrl = images[idx];
            img.src = imgUrl || placeholderSVG(idx);
            img.alt = 'Gallery image';
            img.loading = 'lazy';
            card.appendChild(img);
            rowEl.appendChild(card);
          }
        }
        wrapper.appendChild(rowEl);
        container.appendChild(wrapper);
      }
    }

    /* Rotating words */
    function initWordRotation(sectionId, words, intervalMs) {
      if (!words || words.length < 1) return;
      var el = document.getElementById('rotating-word-' + sectionId);
      if (!el) return;

      el.textContent = words[0].text;
      el.style.color = words[0].color;

      if (words.length < 2) return;

      var idx = 0;
      setInterval(function() {
        el.classList.add('fade-out');
        setTimeout(function() {
          idx = (idx + 1) % words.length;
          el.textContent = words[idx].text;
          el.style.color = words[idx].color;
          el.classList.remove('fade-out');
          el.classList.add('fade-in');
        }, 400);
      }, intervalMs);
    }

    /* Init on page load */
    document.addEventListener('DOMContentLoaded', function() {
      document.querySelectorAll('.hero-section-root').forEach(initHeroBanner);
    });

    /* Theme Editor live reload */
    document.addEventListener('shopify:section:load', function(e) {
      initHeroBanner(e.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["welcome-video"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-wvid-player]').forEach(function (p) {
      if (p.__wvidInit) return;
      p.__wvidInit = true;
      var btn = p.querySelector('.wvid-tile__play');
      if (!btn || btn.disabled) return;
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        p.classList.add('is-playing');
        var media = p.querySelector('[data-wvid-media]');
        var iframe = p.querySelector('[data-wvid-iframe]');
        if (media && media.tagName === 'VIDEO') {
          media.play();
        } else if (iframe) {
          var lazy = iframe.getAttribute('data-src');
          if (lazy) iframe.setAttribute('src', lazy);
        }
      });
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
